import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownItem, DropdownLink } from '@strava/ui/Dropdown';

import styles from './styles.scss';

const EntryActions = ({ activityId, shareable, twitterUrl }) => {
  function facebookShareUrl() {
    const activityUrl = `https://www.strava.com/activities/${activityId}`;
    // Facebook will error if the URL is not publicly available (like with localhost)
    // In which case, you can test using a stubbed route like:
    // const pageUrl = 'https://www.strava.com/activitiy/22481075';
    return `https://www.facebook.com/sharer.php?u=${activityUrl}`;
  }

  function openShareWindow() {
    const left = (window.screen.width - 570) / 2;
    const top = (window.screen.height - 570) / 2;
    const params = `menubar=no,toolbar=no,status=no,width=570,height=570,top=${top},left=${left}`;
    // Setting 'params' to an empty string will launch
    // content in a new tab or window rather than a pop-up.
    // params = "";
    window.open(facebookShareUrl(), 'NewWindow', params);
  }

  return (
    <div className={styles.entryActions} data-testid="entry_actions_container">
      {shareable && (
        <div data-testid="shareable">
          <Dropdown text="" className={`${styles.dropdown}`}>
            <DropdownItem
              href="#"
              onSelect={openShareWindow}
              className={`${styles.dropdownOption}`}
            >
              Facebook
            </DropdownItem>
            <DropdownLink
              href={twitterUrl}
              className={`${styles.dropdownOption}`}
            >
              Twitter
            </DropdownLink>
          </Dropdown>
        </div>
      )}
    </div>
  );
};

EntryActions.propTypes = {
  activityId: PropTypes.string.isRequired,
  shareable: PropTypes.bool.isRequired,
  twitterUrl: PropTypes.string.isRequired
};

export default EntryActions;
